import chroma from 'chroma-js';

const COLOR_MIX = [{ mix: 0.9, value: 'white' }, { mix: 0.7, value: 'white' }, { mix: 0.6, value: 'white' }, { mix: 0.4, value: 'white' }, { mix: 0.2, value: 'white' }, { mix: 0.2, value: 'black' }, { mix: 0.4, value: 'black' }, { mix: 0.6, value: 'black' }, { mix: 0.7, value: 'black' }, { mix: 0.9, value: 'black' }];
const COLOR_MIX_DARKMODE = [{ mix: 0, value: 'white' }, { mix: 0, value: 'white' }, { mix: 0, value: 'white' }, { mix: 0, value: 'white' }, { mix: 0, value: 'white' }, { mix: 0.1, value: 'black' }, { mix: 0.3, value: 'black' }, { mix: 0.5, value: 'black' }, { mix: 0.6, value: 'black' }, { mix: 0.7, value: 'black' }];
const COLOR_MIX_NEUTRAL = [
  { mix: 1, value: 'white' },
  { mix: 0.96, value: 'white' },
  { mix: 0.94, value: 'white' },
  { mix: 0.92, value: 'white' },
  { mix: 0.9, value: 'white' },
  { mix: 0.88, value: 'white' },
  { mix: 0.5, value: 'white' },
  { mix: 0.4, value: 'white' },
  { mix: 0.10, value: 'black' },
  { mix: 0.2, value: 'black' },
  { mix: 0.35, value: 'black' },
  { mix: 0.46, value: 'black' },
  { mix: 0.6, value: 'black' },
];

const generateStyle = ((style, semantics, accents, primary, secondary, neutral) => {
  let theme;
  if (style === 'infused') {
    if (secondary) theme = generateCustomTheme(semantics, adjustInfusedColor(primary), adjustInfusedColor(secondary));
    else theme = generateCustomTheme(semantics, adjustInfusedColor(primary));

    generateInfusedSemantics(theme, semantics);
  } else {
    if (secondary && neutral) theme = generateCustomTheme(semantics, primary, secondary, neutral);
    else if (!secondary && neutral) theme = generateCustomTheme(semantics, primary, null, neutral);
    else if (secondary && neutral) theme = generateCustomTheme(semantics, primary, secondary);
    else theme = generateCustomTheme(semantics, primary);
  }
  
  const accentsColors = generateAccentsColors(semantics, generateMatchingAccentColors(semantics, primary, accents));
  for (const key in accentsColors) {
    for (const id in accentsColors[key]) {
      const name = accentsColors[key][id].colorName;
      const lastIndex = name.lastIndexOf('-');
      const colorName = name.substring(0, lastIndex);
      const atomicNumber = name.substring(lastIndex + 1);
      if (key === 'accentsDarkMode') {
        theme.darkModeTokens.theme[name] = accentsColors[key][id].color;
        createSemantics(colorName, atomicNumber, theme.darkModeTokens.theme, accentsColors, key, id, true);
      } else {
        theme.lightModeTokens.theme[name] = accentsColors[key][id].color;
        createSemantics(colorName, atomicNumber, theme.lightModeTokens.theme, accentsColors, key, id, false);
      }
    }
  }
  return theme;
});

const generateMatchingAccentColors = ((semantics, referenceColor, accents) => {
	const referenceHSL = chroma(referenceColor).hsl();
	const newAccents = [...accents];
  let targetHSL;
	accents.forEach((color, index) => {
		if (color.type === semantics.defaultNames.attention) color.color = referenceColor;
		if (color.type === semantics.defaultNames.lightAttention) {

			const refHSL = chroma(referenceColor).hsl();

			const h = refHSL[0];
			const s = refHSL[1];
			const l = refHSL[2];

			let nh;
			let ns;
			let nl;

			if (h > 300) nh = h - 60;
			else nh = h + 60;

			if (s > 0.86) ns = s - 0.14;
			else ns = s + 0.14;

			if (l > 0.97) nl = l - 0.03;
			else nl = l + 0.03;

			color.color = chroma.hsl(nh, ns, nl).hex();
		}
    
    const adjustedSaturation = referenceHSL[1] > 0.2 ? referenceHSL[1] : 0.3;
    const adjustedLightness = referenceHSL[1] > 0.2 ? referenceHSL[2] : 0.3;
    
    if (color.type != semantics.defaultNames.trivial) {
      targetHSL = chroma(color.color).hsl();
      newAccents[index].color = chroma.hsl(targetHSL[0], adjustedSaturation, adjustedLightness).hex();
    }
		
if (color.type === semantics.defaultNames.valid || color.type === semantics.defaultNames.pending) {
  const minSaturation = 0.2;
  const maxSaturation = 0.8;
  const minLightness = 0.3;
  const maxLightness = 0.7;
  const targetContrastRatio = 2;
  
  let adjustedHue = targetHSL[0];
  let adjustedSaturation = targetHSL[1];
  let adjustedLightness = targetHSL[2];
  
  let color = chroma.hsl(adjustedHue, 
                         Math.max(minSaturation, Math.min(maxSaturation, adjustedSaturation)), 
                         Math.max(minLightness, Math.min(maxLightness, adjustedLightness)));

  let contrastRatio = getContrastRatio(color.hex(), "#fff");

  // Adjust lightness to achieve at least the target contrast ratio
  while (contrastRatio < targetContrastRatio && adjustedLightness < maxLightness) {
    adjustedLightness += 0.01; // Increment lightness
    color = chroma.hsl(adjustedHue, adjustedSaturation, adjustedLightness);
    contrastRatio = getContrastRatio(color.hex(), "#fff");
  }
  
  // If the loop ended due to hitting the max lightness, we need to check and possibly decrease lightness
  while (contrastRatio < targetContrastRatio && adjustedLightness > minLightness) {
    adjustedLightness -= 0.01; // Decrement lightness
    color = chroma.hsl(adjustedHue, adjustedSaturation, adjustedLightness);
    contrastRatio = getContrastRatio(color.hex(), "#fff");
  }

  newAccents[index].color = color.hex(); // Set the adjusted color
}

	});
	return newAccents;
});

function generateAccentsColors(semantics, accentsColors) {
  const accents = [];
  const accentsDarkMode = [];
  const colorName = 50;
  accentsColors.forEach((accent) => {
    createPalette(semantics, accents, false, colorName, COLOR_MIX, accent, + 0, + 0);
  });
  const accentDmColor = generateAccentsDmColors(semantics, accents);
  accentDmColor.forEach(color => {
    createPalette(semantics, accentsDarkMode, true, colorName, COLOR_MIX_DARKMODE, color, + 0, + 0);
  });

  return { accents, accentsDarkMode };
}

function generateAccentsDmColors(semantics, accentsColors) {
  const accentDmColor = [];
  for (const id in accentsColors) {
    switch (accentsColors[id].colorName.toUpperCase()) {
      case `${semantics.defaultNames.valid.toUpperCase()}-300`:
        accentDmColor.push({type: semantics.defaultNames.valid, color: accentsColors[id].color});
        break;
      case `${semantics.defaultNames.attention.toUpperCase()}-300`:
        accentDmColor.push({type: semantics.defaultNames.attention, color: accentsColors[id].color});
        break;
      case `${semantics.defaultNames.pending.toUpperCase()}-300`:
        accentDmColor.push({type: semantics.defaultNames.pending, color: accentsColors[id].color});
        break;
      case `${semantics.defaultNames.error.toUpperCase()}-300`:
        accentDmColor.push({type: semantics.defaultNames.error, color: accentsColors[id].color});
        break;
      case `${semantics.defaultNames.message.toUpperCase()}-300`:
        accentDmColor.push({type: semantics.defaultNames.message, color: accentsColors[id].color});
        break;
      case `${semantics.defaultNames.lightAttention.toUpperCase()}-300`:
        accentDmColor.push({type: semantics.defaultNames.lightAttention, color: accentsColors[id].color});
        break;
      case `${semantics.defaultNames.trivial.toUpperCase()}-300`:
        accentDmColor.push({type: semantics.defaultNames.trivial, color: accentsColors[id].color});
        break;
    }
  }
  return accentDmColor;
}

const createSemantics = ((colorName, atomicNumber, theme, accents, key, id, isDarkMode) => {
  switch (atomicNumber) {
    case '50':
      theme[`${colorName}-background`] = accents[key][id].color;
      break;
    case '500':
      theme[`${colorName}`] = accents[key][id].color;
      theme[`text-on-${colorName}`] = isColorBright(accents[key][id].color) ? theme['neutral-1000'] : theme['neutral-0'];
      // Adding white to the color for better contrast ratio in dark mode only
      if (isDarkMode) theme[`text-on-${colorName}-background`] = chroma.mix(accents[key][id].color, 'white', 0.3, 'hsl').hex();
      break;
    case '800':
      if (!isDarkMode) theme[`text-on-${colorName}-background`] = accents[key][id].color;
  }
});

const adjustInfusedColor = ((color) => {
  const l = chroma(color).get('hsl.l');
  if (l > 0.8) color = chroma(color).set('hsl.l', 0.8).hex();
  if (l < 0.2) color = chroma(color).set('hsl.l', 0.2).hex();

  return color;
});

const defaultConfig = {
  keyFormat: 'snakeCase'
};

const generateCustomTheme = (semantics, primaryColor, secondaryColor, neutralColor, config = defaultConfig) => {
  const primary = primaryColor ? { color: primaryColor, type: semantics.defaultNames.primary } : null;
  const secondary = secondaryColor ? { color: secondaryColor, type: semantics.defaultNames.secondary } : null;
  const neutral = neutralColor ? { color: neutralColor, type: semantics.defaultNames.neutral } : null;

  const { colorPalette, colorPaletteDarkMode } = generateThemeColors([primary, secondary, neutral].filter(el => el), semantics);

  // Accents are statics
  // use mapNeutral palette to generate semantics colors
  const semanticLight = mapNeutralPalette(false, colorPalette, semantics);
  const semanticDark = mapNeutralPalette(true, colorPaletteDarkMode, semantics);

  const lightModeTokens = {
    theme: reduceColorPalette([...semanticLight, ...colorPalette]),
  };
  const darkModeTokens = {
    theme: reduceColorPalette([...semanticDark, ...colorPaletteDarkMode]),
  };

  return {
    lightModeTokens,
    darkModeTokens
  }
};

const generateInfusedSemantics = ((theme, userSemantics) => {
  const semantics = ['background', userSemantics.defaultNames.contentBg, userSemantics.defaultNames.contentBgTwo, userSemantics.defaultNames.contentBgThree, userSemantics.defaultNames.contentBgDisabled, userSemantics.defaultNames.contentBgTwoDisabled, userSemantics.defaultNames.contentBgThreeDisabled];
  const texts = [userSemantics.defaultNames.textPrimary, userSemantics.defaultNames.textSecondary, userSemantics.defaultNames.textDisabled];

  const mix = [0.05, 0.11, 0.14, 0.18, 0, 0, 0];
  const mixDm = [0.02, 0.03, 0.05, 0.07, 0, 0, 0];

  const mixText = [0.1, 0.3, 0];
  const mixTextDm = [0.2, 0.65, 0];

  let initialColor;

  const initialBgDm = '#000000';
  const initialBg = '#FFFBFF';

  Object.keys(theme).forEach(mode => {
    if (mode.includes('lightMode')) {
      const lm = theme[mode].theme;
      Object.keys(lm).forEach(name => {
        initialColor = lm[`${userSemantics.defaultNames.primary}-500`];
        if (name.includes(`${userSemantics.defaultNames.primary}-500`)) {
          if (chroma(initialColor).get('hsl.l') > 0.5) initialColor = chroma(lm[`${userSemantics.defaultNames.primary}-500`]).set('hsl.l', 0.45);
          mix.forEach((value, index) => {
            lm[semantics[index]] = chroma.mix(initialBg, initialColor, value, 'lab').hex();
            if (index === 4) lm[semantics[index]] = turnToTransparent(lm[semantics[index]], lm[semantics[index - 4]], 0.8);
            else if (index === 5) lm[semantics[index]] = turnToTransparent(lm[semantics[index]], lm[semantics[index - 4]], 0.6);
            else if (index === 6) lm[semantics[index]] = turnToTransparent(lm[semantics[index]], lm[semantics[index - 4]], 0.5);
          });
          mixText.forEach((value, index) => {
            lm[texts[index]] = chroma.mix(initialBgDm, initialColor, value, 'lab').hex();
            if (index === 2) lm[texts[index]] = turnToTransparent(lm[texts[index]], lm.background, 0.3);
          });
        } else if (name === userSemantics.defaultNames.border) {
          initialColor = lm[`${userSemantics.defaultNames.primary}-500`];
          lm[userSemantics.defaultNames.border] = chroma.mix(initialBg, initialColor, 0.24).hex();
        }
      });
    } else {
      const dm = theme[mode].theme;
      Object.keys(dm).forEach(name => {
        initialColor = dm[`${userSemantics.defaultNames.primary}-500`];
        if (name.includes(userSemantics.defaultNames.primary)) {
          if (chroma(initialColor).get('hsl.l') < 0.77) initialColor = chroma(dm[`${userSemantics.defaultNames.primary}-500`]).set('hsl.l', 0.75);
          if (chroma(initialColor).get('hsl.s') < 0.7) initialColor = chroma(dm[`${userSemantics.defaultNames.primary}-500`]).set('hsl.s', 0.7);
          mixDm.forEach((value, index) => {
            dm[semantics[index]] = chroma.mix(initialBgDm, initialColor, value).hex();
            if (index === 4) dm[semantics[index]] = turnToTransparent(dm[semantics[index]], dm[semantics[index - 4]], 0.2);
            else if (index === 5) dm[semantics[index]] = turnToTransparent(dm[semantics[index]], dm[semantics[index - 3]], 0.4);
            else if (index === 6) dm[semantics[index]] = turnToTransparent(dm[semantics[index]], dm[semantics[index - 3]], 0.5);
          });
          mixTextDm.forEach((value, index) => {
            dm[texts[index]] = chroma.mix(initialBg, initialColor, value).hex();
            if (index === 2) dm[texts[index]] = turnToTransparent(dm[texts[index]], dm.background, 0.2);
          });
        } else if (name === userSemantics.defaultNames.border) {
          dm[userSemantics.defaultNames.border] = dm['background'];
        }
      });
    }
  });
});

function generateThemeColors(colors, semantics) {
  checkFormat(semantics, colors);

  const colorPalette = [];
  const colorPaletteDarkMode = [];
  const colorName = 50;

  const types = colors.map(x => x.type.toUpperCase());

  let primaryColor = colors.find(c => c.type.toUpperCase() === semantics.defaultNames.primary.toUpperCase()).color;
  let secondaryColor = types.includes(semantics.defaultNames.secondary.toUpperCase()) ? colors.find(c => c.type.toUpperCase() === semantics.defaultNames.secondary.toUpperCase()).color : null;

  const colorIsBright = ((color) => { return Number(chroma(color).luminance()).toFixed(3) > 0.710 });
  const colorIsDark = ((color) => { return Number(chroma(color).luminance()).toFixed(3) < 0.012 });
  const colorIsWhite = ((color) => { return chroma(color).get('hsl.l') > 0.86; });
  const turnToGrey = ((color) => { return chroma(color).set('hsl.l', 0.85).hex() });

  if (!types.includes(semantics.defaultNames.neutral.toUpperCase())) colors.push({ type: semantics.defaultNames.neutral, color: '#3C3847' });
  if (!types.includes(semantics.defaultNames.secondary.toUpperCase())) colors.push({ type: semantics.defaultNames.secondary, color: getSplitComplementaryColor(colors.find(c => c.type.toUpperCase() === semantics.defaultNames.primary.toUpperCase()).color) });

  if (secondaryColor != null && colorIsWhite(secondaryColor)) colors[1].color = turnToGrey(secondaryColor);
  colors.forEach((color, index) => {
    if (colorIsBright(color.color)) {
      if (colorIsWhite(color.color)) colors[index].color = turnToGrey(primaryColor);
      createPalette(semantics, colorPalette, false, colorName, COLOR_MIX, color, - 0.2, + 0.04);
    } else if (colorIsDark(color.color)) {
      createPalette(semantics, colorPalette, false, colorName, COLOR_MIX, color, + 0.05, - 0.07);
    } else {
      createPalette(semantics, colorPalette, false, colorName, COLOR_MIX, color, + 0, + 0);
    }
  });

  const dmColor = generateMainDmColors(semantics, colorPalette);
  // TO REVERT IF NECESSARY TRYING TO FIX DARK MODE COLORS
  const getColor = (color) => {
    const foundColor = colorPalette.find(c => c.colorName === color).color;
    return foundColor ? foundColor : null;
  };
  // changing the mix value to the dynamically generated background dark mode only
  // This allows better color definition for dark mode colors from 50 to 500
  let initialColor;
  COLOR_MIX_DARKMODE.map(item => {
    if (item.value === 'white') {
      item.value = getColor(`${semantics.defaultNames.neutral}-1000`);
    }
  });
  dmColor.forEach(color => {
    if (color.type === semantics.defaultNames.primary) {
      initialColor = getColor(`${semantics.defaultNames.primary}-500`);
    } else if (color.type === semantics.defaultNames.secondary) {
      initialColor = getColor(`${semantics.defaultNames.secondary}-500`);
    } else if (color.type === semantics.defaultNames.neutral) {
      initialColor = null;
    }
    createPalette(semantics, colorPaletteDarkMode, true, colorName, COLOR_MIX_DARKMODE, color, 0, 0, initialColor);
  });

  return { colorPalette, colorPaletteDarkMode };
}

const mapNeutralPalette = function (isDarkMode, palette, semantics, accentPalette,) {
  const getColor = (color) => {
    const foundColor = palette.find(c => c.colorName === color).color;
    return foundColor ? foundColor : null;
  };
  let returnedArr = [];
  if (isDarkMode) {
    returnedArr = [
      { colorName: `background`, color: getColor(`${semantics.defaultNames.neutral}-1000`) },
      { colorName: semantics.defaultNames.contentBg, color: getColor(`${semantics.defaultNames.neutral}-900`) },
      { colorName: semantics.defaultNames.contentBgTwo, color: getColor(`${semantics.defaultNames.neutral}-800`) },
      { colorName: semantics.defaultNames.contentBgThree, color: getColor(`${semantics.defaultNames.neutral}-700`) },
      { colorName: semantics.defaultNames.contentBgDisabled, color: turnToTransparent(getColor(`${semantics.defaultNames.neutral}-900`), getColor(`${semantics.defaultNames.neutral}-1000`), 0.4) },
      { colorName: semantics.defaultNames.contentBgTwoDisabled, color: turnToTransparent(getColor(`${semantics.defaultNames.neutral}-800`), getColor(`${semantics.defaultNames.neutral}-900`), 0.6) },
      { colorName: semantics.defaultNames.contentBgThreeDisabled, color: turnToTransparent(getColor(`${semantics.defaultNames.neutral}-700`), getColor(`${semantics.defaultNames.neutral}-800`), 0.8) },
      { colorName: semantics.defaultNames.textPrimary, color: getColor(`${semantics.defaultNames.neutral}-0`) },
      { colorName: semantics.defaultNames.textDisabled, color: turnToTransparent(getColor(`${semantics.defaultNames.neutral}-0`), getColor(`${semantics.defaultNames.neutral}-1000`), 0.5) },
      { colorName: semantics.defaultNames.textSecondary, color: turnToTransparent(getColor(`${semantics.defaultNames.neutral}-0`), getColor(`${semantics.defaultNames.neutral}-900`), 0.68) },
      { colorName: `text-on-${semantics.defaultNames.primary}`, color: isColorBright(getColor(`${semantics.defaultNames.primary}-500`)) ? getColor(`${semantics.defaultNames.neutral}-1000`) : getColor(`${semantics.defaultNames.neutral}-0`) },
      { colorName: `text-on-${semantics.defaultNames.secondary}`, color: isColorBright(getColor(`${semantics.defaultNames.secondary}-500`)) ? getColor(`${semantics.defaultNames.neutral}-1000`) : getColor(`${semantics.defaultNames.neutral}-0`) },
      { colorName: semantics.defaultNames.border, color: getColor(`${semantics.defaultNames.neutral}-800`) },
      { colorName: `${semantics.defaultNames.primary}-background`, color: getColor(`${semantics.defaultNames.primary}-50`) },
      // Adding white to the color for better contrast ratio in dark mode only
      { colorName: `text-on-${semantics.defaultNames.primary}-background`, color: chroma.mix(getColor(`${semantics.defaultNames.primary}-500`), 'white', 0.3, 'hsl').hex() },
      { colorName: `${semantics.defaultNames.secondary}-background`, color: getColor(`${semantics.defaultNames.secondary}-50`) },
      // Adding white to the color for better contrast ratio in dark mode only
      { colorName: `text-on-${semantics.defaultNames.secondary}-background`, color: chroma.mix(getColor(`${semantics.defaultNames.secondary}-500`), 'white', 0.3, 'hsl').hex() },
    ];
  } else {
    returnedArr = [
      { colorName: `background`, color: getColor(`${semantics.defaultNames.neutral}-50`) },
      { colorName: semantics.defaultNames.contentBg, color: getColor(`${semantics.defaultNames.neutral}-0`) },
      { colorName: semantics.defaultNames.contentBgTwo, color: getColor(`${semantics.defaultNames.neutral}-50`) },
      { colorName: semantics.defaultNames.contentBgThree, color: getColor(`${semantics.defaultNames.neutral}-0`) },
      { colorName: semantics.defaultNames.contentBgDisabled, color: turnToTransparent(getColor(`${semantics.defaultNames.neutral}-0`), getColor(`${semantics.defaultNames.neutral}-50`), 0.8) },
      { colorName: semantics.defaultNames.contentBgTwoDisabled, color: turnToTransparent(getColor(`${semantics.defaultNames.neutral}-50`), getColor(`${semantics.defaultNames.neutral}-0`), 0.6) },
      { colorName: semantics.defaultNames.contentBgThreeDisabled, color: turnToTransparent(getColor(`${semantics.defaultNames.neutral}-0`), getColor(`${semantics.defaultNames.neutral}-50`), 0.5) },
      { colorName: semantics.defaultNames.textPrimary, color: getColor(`${semantics.defaultNames.neutral}-1000`) },
      { colorName: semantics.defaultNames.textDisabled, color: turnToTransparent(getColor(`${semantics.defaultNames.neutral}-1000`), getColor(`${semantics.defaultNames.neutral}-0`), 0.3) },
      { colorName: semantics.defaultNames.textSecondary, color: turnToTransparent(getColor(`${semantics.defaultNames.neutral}-1000`), getColor(`${semantics.defaultNames.neutral}-0`), 0.6) },
      { colorName: `text-on-${semantics.defaultNames.primary}`, color: isColorBright(getColor(`${semantics.defaultNames.primary}-500`)) ? getColor(`${semantics.defaultNames.neutral}-1000`) : getColor(`${semantics.defaultNames.neutral}-0`) },
      { colorName: `text-on-${semantics.defaultNames.secondary}`, color: isColorBright(getColor(`${semantics.defaultNames.secondary}-500`)) ? getColor(`${semantics.defaultNames.neutral}-1000`) : getColor(`${semantics.defaultNames.neutral}-0`) },
      { colorName: semantics.defaultNames.border, color: getColor(`${semantics.defaultNames.neutral}-100`) },
      { colorName: `${semantics.defaultNames.primary}-background`, color: getColor(`${semantics.defaultNames.primary}-50`) },
      { colorName: `text-on-${semantics.defaultNames.primary}-background`, color: getColor(`${semantics.defaultNames.primary}-900`) },
      { colorName: `${semantics.defaultNames.secondary}-background`, color: getColor(`${semantics.defaultNames.secondary}-50`) },
      { colorName: `text-on-${semantics.defaultNames.secondary}-background`, color: getColor(`${semantics.defaultNames.secondary}-900`) },
    ];
  }
  returnedArr = [
    ...returnedArr,
    { colorName: semantics.defaultNames.primary, color: getColor(`${semantics.defaultNames.primary}-500`) },
    { colorName: semantics.defaultNames.secondary, color: getColor(`${semantics.defaultNames.secondary}-500`) },
  ];

  return [...returnedArr];
};

function reduceColorPalette(colorPalette) {
  return colorPalette.reduce((acc, curr) => {
    if (!curr.colorName.includes('gradient')) {
      acc[curr.colorName] = curr.color;
    }
    return acc;
  }, {});
}

function turnToTransparent(color, backgroundColor, alphaValue) {
  const originalColor = chroma(color).alpha(alphaValue);

  const rgb = chroma(originalColor).rgb();
  const alpha = chroma(originalColor).alpha();

  const bgRgb = chroma(backgroundColor).rgb();

  const opaqueRGB = rgb.map((value, index) => {
    return Math.round(value * alpha + bgRgb[index] * (1 - alpha));
  });

  const opaqueColor = chroma(opaqueRGB);
  const opaqueHex = chroma(opaqueColor).hex();

  return opaqueHex;
}

function createPalette(semantics, palette, darkmode, name, mixArray, color, mixValueWhite, mixValueBlack, initialColor) {
  if (color.type.toUpperCase() === semantics.defaultNames.neutral.toUpperCase()) {
    COLOR_MIX_NEUTRAL.forEach((item, mixIndex) => {
      if (mixIndex === 0) name = 0;
      else if (mixIndex === 1) name = 50;
      else if (mixIndex === 2) name = 100;
      else name += 100;
      if (name === 700) name = 800;
      palette.push({
        colorName: `${color.type}-${name}`,
        color: chroma.mix(color.color, item.value, item.mix, 'hsl').hex(),
      });
    });
  } else {
    mixArray.forEach((item, mixIndex) => {
      let mix = item.mix;
      mix += item.value === 'white' ? mixValueWhite : mixValueBlack;
      if (mixIndex === 0) name = 50;
      else if (mixIndex === 1) name = 100;
      else name += 100;
      const darkModeMixValue = [0.2, 0.3, 0.4, 0.5, 0.7, 1, 1, 1, 1, 1, 1];
      if (name === 500) name = 600;
      if (mixIndex <= 4 && darkmode) {
        palette.push({
          colorName: `${color.type}-${name}`,
          // To define the color we use turnToTransparent to modify the alpha and get the color we want but as a color without an alpha in the hex code
          color: turnToTransparent(color.color, item.value, darkModeMixValue[mixIndex])
        });
      } else if (darkmode && mixIndex > 4 && initialColor != null) {
        palette.push({
          colorName: `${color.type}-${name}`,
          color: chroma.mix(initialColor, item.value, mix, 'hsl').hex(),
        });
      } else {
        palette.push({
          colorName: `${color.type}-${name}`,
          color: chroma.mix(color.color, item.value, mix, 'hsl').hex(),
        });
      }
    });
  }
  if (color.type.toUpperCase() === semantics.defaultNames.neutral.toUpperCase()) palette.push({ colorName: `${color.type}-700`, color: color.color });
  else palette.push({ colorName: `${color.type}-500`, color: color.color });
}

function generateMainDmColors(semantics, colors) {
  const dmColor = [];
  for (const id in colors) {
    switch (colors[id].colorName.toUpperCase()) {
      // TO REVERT IF NECESSARY WAS -100
      case `${semantics.defaultNames.primary.toUpperCase()}-300`:
        dmColor.push({ type: semantics.defaultNames.primary, color: colors[id].color });
        break;
      case `${semantics.defaultNames.secondary.toUpperCase()}-300`:
        dmColor.push({ type: semantics.defaultNames.secondary, color: colors[id].color });
        break;
      case `${semantics.defaultNames.neutral.toUpperCase()}-700`:
        dmColor.push({ type: semantics.defaultNames.neutral, color: colors[id].color });
    }
  }
  return dmColor;
}

function getSplitComplementaryColor(primaryColor) {
  // Convert hex to HSL
  const hsl = chroma(primaryColor).hsl();
  
  // Adjust Hue to get Split Complementary Color
  let h = hsl[0];
  h = (h - 250) % 360; 
  if (h < 0) h += 360;  // Handle negative values

  // Convert HSL back to hex
  const hex = chroma.hsl(h, hsl[1], hsl[2]).hex();
  return hex;
}

const isColorBright = function (color) {
  return Number(chroma(color).luminance()).toFixed(3) > 0.25;
};

function getContrastRatio(color1, color2) {
  const luminance1 = chroma(color1).luminance();
  const luminance2 = chroma(color2).luminance();
  
  return (Math.max(luminance1, luminance2) + 0.05) / (Math.min(luminance1, luminance2) + 0.05);
}

const checkFormat = function (semantics, arr) {
  if (arr.length > 3) throw Error("Maximun of 3 colors exceeded. You can define up to 3 colors only");
  if (arr.length <= 2) {
    let arrMap = arr.map(x => x.type.toUpperCase());
    if (!arrMap.includes(semantics.defaultNames.primary.toUpperCase())) throw Error("A Primary color is expected")
  }
  arr.forEach((i, index) => {
    switch (i.type.toUpperCase()) {
      case semantics.defaultNames.primary.toUpperCase():
        break;
      case semantics.defaultNames.secondary.toUpperCase():
        break;
      case semantics.defaultNames.neutral.toUpperCase():
        const luminance = chroma(i.color).luminance().toFixed(3);
        if (luminance > 0.042) throw Error(`Color-${i.type} @ Array[${index}].color is too bright for being a background color`)
        else if (luminance < 0.010) throw Error(`Color-${i.type} @ Array[${index}].color is too dark for being a background color`)
        break;
      default:
        throw Error(`Color-${i.type} @ Array[${index}].type has wrong format. This parameter can only take either Primary, Secondary or Neutral`)
    }    if (!i.color.includes('#')) throw Error(`Color-${i.type} @ Array[${index}].color isn't hex. Missing #`);
    if (i.color.length > 9) throw Error(`Color-${i.type} @ Array[${index}].color doesn't respect #RRGGBBAA format`)
  });
};

const generateTheme = function ({ style, primary, secondary, neutral, platform, accents, semantics }) {
    const defaultNames = {
      primary: 'primary',
      secondary: 'secondary',
      neutral: 'neutral',
      valid: 'valid',
      error: 'error',
      pending: 'pending',
      attention: 'attention',
      lightAttention: 'light-attention',
      message: 'message',
      trivial: 'trivial',
      textPrimary: 'text-primary',
      textDisabled: 'text-on-disabled',
      textSecondary: 'text-secondary',
      contentBg: 'content-background',
      contentBgTwo: 'content-background-2',
      contentBgThree: 'content-background-3',
      contentBgDisabled: 'content-background-disabled',
      contentBgTwoDisabled: 'content-background-2-disabled',
      contentBgThreeDisabled: 'content-background-3-disabled',
      border: 'border'
    };

    if (!['default', 'infused'].includes(style)) {
      throw new Error('Invalid style parameter. Allowed values are "default" or "infused".');
    }
    
    if (!semantics) {
      semantics = { defaultNames };
    }

    if (!accents) {
      accents = [
        {
          type: semantics.defaultNames.valid,
          color: '#30AF84'
        },
        {
          type: semantics.defaultNames.error,
          color: '#D62C1D'
        },
        {
          type: semantics.defaultNames.pending,
          color: '#A3A11D'
        },
        {
          type: semantics.defaultNames.attention,
          color: primary
        },
        {
          type: semantics.defaultNames.message,
          color: '#5F99DB'
        },
        {
          type: semantics.defaultNames.lightAttention,
          color: '#E146C1'
        },
        {
          type: semantics.defaultNames.trivial,
          color: style === 'default' && neutral ? neutral : "#262626"
        }
      ];
    }
    const hexColorRegex = /^#([0-9A-Fa-f]{3}){1,2}$/;
  
    if (!hexColorRegex.test(primary)) {
      throw new Error('Invalid color format for primary. Expected format is a valid hex color code (e.g., #FFF or #FFFFFF), with no alpha channel.');
    }
  
    if ((secondary && !hexColorRegex.test(secondary)) || (neutral && !hexColorRegex.test(neutral))) {
      throw new Error('Invalid color format for secondary or neutral. Expected format is a valid hex color code (e.g., #FFF or #FFFFFF), with no alpha channel.');
    }
  
    let theme;

    if (style != 'infused') {
      if (!secondary && !neutral) theme = generateStyle(style, semantics, accents, primary);
      else if (secondary && !neutral) theme = generateStyle(style, semantics, accents, primary, secondary);
      else if (secondary && neutral) theme = generateStyle(style, semantics, accents, primary, secondary, neutral);
      else if (!secondary && neutral) theme = generateStyle(style, semantics, accents, primary, null, neutral);
    } else {
      if (!secondary) theme = generateStyle(style, semantics, accents, primary);
      else theme = generateStyle(style, semantics, accents, primary, secondary);
    }
    return theme;
};

export { generateTheme };
